import React from 'react'

import { HStack } from '~/components/elements/HStack'

import styles from './InputContainer.css'

export type InputContainerProps = React.PropsWithChildren

export const InputContainer = ({ children }: InputContainerProps) => (
  <HStack className={styles.root} padding={2} spacing={4}>
    {children}
  </HStack>
)
